import { KeyValue } from '@/main/models/common';
import { IntegrationTriggerTypes, IntegrationTriggerActionTypes } from './integrationTriggerTypes';

export function getIntegrationTrigger(): IntegrationTriggerActionTypes {
  return {
    type: IntegrationTriggerTypes.GET_INTEGRATION_TRIGGER,
  };
}

export function saveIntegrationTrigger(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null
): IntegrationTriggerActionTypes {
  return {
    type: IntegrationTriggerTypes.SAVE_INTEGRATION_TRIGGER,
    payload: { data, isError, errorMessages }
  };
}

export function resetReducerIntegrationTrigger(): IntegrationTriggerActionTypes {
  return {
    type: IntegrationTriggerTypes.RESET_INTEGRATION_TRIGGER
  };
}
